import orderInstance from '../instance'

const updateOrderPickupStatus = (orderId, status) => {
	return orderInstance.put(`/orders/${orderId}/pickupStatus`, { status })
}

export default updateOrderPickupStatus
